<template>
  <Drawer v-model="visible" >
    <div class="join-circle">
      <p>{{$t('requests')}}</p>
      <el-input
        v-model="applyReasons"
        :maxlength="cloudConfig.circleUserApplyReasonLimit"
        :rows="15"
        placeholder="Please input"
        show-word-limit
        type="textarea"
        resize="none"
      />
      <div>
        <el-button class="cancel" @click="onCancel">{{$t('cancel')}}</el-button>
        <el-button class="send" @click="onSend" :disabled="!applyReasons" :loading="sending">{{$t('send')}}</el-button>
      </div>
    </div>
  </Drawer>
</template>

<script setup>
import Drawer from '@/components/web/drawer'

import http from '@/service'
import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia';
import { getCurrentInstance, ref, watch } from 'vue';


const systemStore = useSystemStore()

const { cloudConfig } = storeToRefs(systemStore)

const { proxy } = getCurrentInstance()

const emit = defineEmits(['update:modelValue', 'onPending'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: ''
  }
})

// 抽屉开关
const visible = ref(false)

const applyReasons = ref('')

const sending = ref(false)

const onCancel = () => {
  visible.value = false
}

const onSend = async () => {
  sending.value = true
  const { code, data, msg} = await http.joinCircle({
    applyReason: applyReasons.value,
    id: props.id
  })
  if (code === 200 && data) {
    visible.value = false
    emit('onPending', 5)
    proxy.$toast({
      message: msg,
    })
  } else {
    proxy.$toast({
      message: msg,
    })
  }
  sending.value = false
}

watch(() => visible.value, (val) => {
  if (val) {
  
  } else {
    applyReasons.value = ''
    emit('update:modelValue', val)
  }
}, {
  immediate: true,
  deep: true
})

// 同步开关
watch(() => props.modelValue, (val) => {
  visible.value = val
}, {
  immediate: true
})

</script>

<style lang="postcss" scoped>
.join-circle {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  width: 792px;
  margin: 0 auto;
}
p {
  font-family: "orbit-M";
  font-size: 28px;
  line-height: 100%;
  margin: 12px 0 48px;
}
.el-textarea {
  --el-input-bg-color: #F9F9F9;
  --el-fill-color-blank: #F9F9F9;
  --el-input-border-radius: 24px;
  font-size: 18px;
  line-height: 23px;
  :deep(.el-textarea__inner) {
    padding: 24px;
    box-shadow: none;
    &::placeholder {
      color: var(--text-hint);
    }
  }
  :deep(.el-input__count) {
    font-size: 14px;
    bottom: 24px;
    right: 24px;
  }
}

.el-button {
  --el-button-bg-color: var(--theme);
  --el-button-active-color: var(--theme);
  --el-color-primary-dark-2: var(--theme);
  --el-button-hover-bg-color: var(--theme);
  --el-button-disabled-bg-color: var(--theme-disabled);
  --el-button-disabled-text-color: #FFF;
  width: 240px;
  height: 48px;
  font-family: "orbit-M";
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: #FFFFFF;
  border-radius: var(--button-radius);
  border: none;
  margin-top: 64px;
  &:first-child {
    margin-right: 155px;
  }
}
.cancel {
  --el-button-bg-color: transparent;
  --el-button-active-color: transparent;
  --el-color-primary-dark-2: transparent;
  --el-button-hover-bg-color: transparent;
  --el-button-disabled-bg-color: var(--theme-disabled);
  color: var(--text-primary);
  border: 1px solid var(--line);
}
</style>